import { render, staticRenderFns } from "./TripHistoryView.vue?vue&type=template&id=3b63d8e4&"
import script from "./TripHistoryView.vue?vue&type=script&lang=js&"
export * from "./TripHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./TripHistoryView.vue?vue&type=style&index=0&id=3b63d8e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TripHistoryView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports